var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAprovado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 40.1512L16.875 30.7744L19.5244 28.125L26.25 34.8488L40.4719 20.625L43.125 23.2781L26.25 40.1512Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.75C24.8083 3.75 19.7331 5.28954 15.4163 8.17392C11.0995 11.0583 7.73497 15.158 5.74817 19.9546C3.76137 24.7511 3.24154 30.0291 4.2544 35.1211C5.26726 40.2131 7.76733 44.8904 11.4385 48.5616C15.1096 52.2327 19.7869 54.7327 24.8789 55.7456C29.9709 56.7585 35.2489 56.2386 40.0454 54.2518C44.842 52.265 48.9417 48.9005 51.8261 44.5837C54.7105 40.2669 56.25 35.1918 56.25 30C56.25 23.0381 53.4844 16.3613 48.5616 11.4384C43.6387 6.51562 36.9619 3.75 30 3.75ZM30 52.5C25.5499 52.5 21.1998 51.1804 17.4997 48.7081C13.7996 46.2357 10.9157 42.7217 9.21272 38.6104C7.50975 34.499 7.06418 29.975 7.93234 25.6105C8.80051 21.2459 10.9434 17.2368 14.0901 14.0901C17.2368 10.9434 21.2459 8.8005 25.6105 7.93233C29.9751 7.06416 34.499 7.50974 38.6104 9.21271C42.7217 10.9157 46.2357 13.7996 48.7081 17.4997C51.1804 21.1998 52.5 25.5499 52.5 30C52.5 35.9674 50.1295 41.6903 45.9099 45.9099C41.6903 50.1295 35.9674 52.5 30 52.5Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 43.2411,
    y1: 26.5508,
    x2: 14.1665,
    y2: 56.2635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843EF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 56.4822,
    y1: 19.6827,
    x2: -18.8587,
    y2: 76.9554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843EF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAprovado);
export default __webpack_public_path__ + "static/media/ico_aprovado.70cca8b120435061ed825016c790078b.svg";
export { ForwardRef as ReactComponent };